<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                Post Term Reports
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details                     
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="terms"
                :search="search"
                :loading="loading"
                loading-text="Loading... Please wait"
                fixed-header
                height="60vh" 
            >
                <template
                    v-slot:top
                >
                    <v-dialog
                        v-model="dialog"
                        max-width="500px"
                        persistent
                    >
                        <v-card
                            v-show="cardPostReport"
                        >
                            <div class="d-flex justify-end pt-2">
                                <v-btn icon @click="cancel" color="red" class="mr-3" >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                            <v-card-title class="d-flex align-center  mb-0 py-0">
                                <span>{{ formText }}</span>
                                <v-spacer></v-spacer>
                                
                            </v-card-title>

                            <v-card-title  class="d-flex align-center justify-space-between pt-0 mb-4">
                                
                            </v-card-title>                            
                            <v-card-text
                                class="text-h6"
                            >
                                <v-sheet color="blue-grey lighten-5" class="pa-2">
                                    <div class="text-caption mb-3">Schedule</div>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-menu
                                                v-model="menuDate"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="dateScheduled"
                                                        label="Date"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                        dense
                                                        hide-details
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dateScheduled"
                                                    @input="menuDate = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
    
                                        <v-col cols="6">
                                            <v-menu
                                                ref="menu"
                                                v-model="menuTime"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="timeScheduled"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="formattedTime"
                                                        label="Time"
                                                        prepend-icon="mdi-clock-time-four-outline"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        outlined
                                                        dense
                                                        hide-details
                                                    ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="menuTime"
                                                    v-model="timeScheduled"
                                                    full-width
                                                    format="ampm"
                                                    @click:minute="$refs.menu.save(timeScheduled)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    
                                </v-sheet>
                                
                            </v-card-text>

                            <v-card-actions class="d-flex justify-space-between mt-3">
                                <v-btn
                                    @click="removeReports"
                                    class="flex-1 mr-2"
                                    depressed
                                >
                                    Unpost Reports
                                </v-btn>
                                <v-btn
                                    depressed
                                    outlined
                                    @click="scheduleNow"
                                    class="flex-1 mr-2"
                                >
                                    Schedule Now
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    @click="postReports"
                                    depressed
                                    class="flex-1"
                                >
                                    Post Now
                                </v-btn>
                            </v-card-actions>
                        </v-card>

                        <v-expand-transition>
                            <v-card
                                color="primary"
                                dark
                                v-show="expand"
                                class="pa-4"
                            >
                                <v-card-text>
                                    {{ postingText }}
                                <v-progress-linear
                                    indeterminate
                                    color="white"
                                    class="mb-0 mt-2"
                                ></v-progress-linear>
                                </v-card-text>
                            </v-card>
                        </v-expand-transition>
                    </v-dialog>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                        text
                        outlined
                        @click="editTerm(item)"
                        small
                    >
                        <v-icon
                            small
                            class="mr-2"
                        >
                            mdi-pencil
                        </v-icon>
                        Edit
                    </v-btn>
                </template>
            </v-data-table>
            
        </v-card>

        <v-snackbar
            v-model="snackbar"
            color="primary"
        >
            {{ snackText }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    data: () => ({
        headers:[
            {
                text: 'Academic Year',
                align: 'center',
                value: 'year'
            },
            {
                text: 'Term',
                align: 'center',
                value: 'title'
            },
            {
                text: 'Posted',
                align: 'center',
                value: 'posted'
            },
            {
                text: 'Date Posted',                
                value: 'date_posted'
            },
            {
                text: 'Scheduled Date',                
                value: 'date_scheduled'
            },
            {
                text: 'Edit',
                align: 'center',
                value: 'actions',
                sortable: false,
            },
        ],
        terms: [],
        search: '',
        loading: true,
        dialog: false,
        editedItem: {},
        snackbar: false,
        snackText: '',
        cardPostReport: true,
        expand: false,
        postingText: '',
        dateScheduled: null,
        menuDate: false,
        menuTime: false,
        timeScheduled: null,
    }),

    created(){
        //console.log('post term reports created');
        this.initialize();
    },

    computed: {
        ...mapGetters({
            menuOptions: 'admin/getMenuOptions',
        }),
        formText () {
            return `${this.editedItem.year} Term ${this.editedItem.term} reports`;
        },
        // snackText () {
        //     return this.editedItem.year + ' Term ' + this.editedItem.term + ' reports posted';
        // },
        // postingText () {
        //     return 'Posting reports please stand by'
        // }
        formattedTime () {
            if(!this.timeScheduled) return '';
            const [hour, minute] = this.timeScheduled.split(':');
            const h = parseInt(hour)
            const ampm = h >= 12 ? 'PM' : 'AM';
            const displayHour = h % 12 || 12;
            return `${displayHour}:${minute} ${ampm}`
        }
    },

    methods: {
        ...mapActions({
            getTermReportsPosted: 'admin/getReportsPosted',
            postTermReports: 'admin/postTermReports',
            scheduleTermReports: 'admin/scheduleTermReports',
        }),
        ...mapMutations({
            setEditedTerm: 'admin/setEditedTerm',
        }),
        async initialize(){
            try {
                const { data } = await this.getTermReportsPosted();
                this.setTermRecords(data);
                this.loading = false;
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        },
        setTermRecords(data){
            this.terms = data.map(term => {
                let reportPosted = 'posted';
                if(term.posted == 0) reportPosted = 'not posted';

                return {
                    year: term.year + '-' + (parseInt(term.year) + 1),
                    term: term.term,
                    title: term.title,
                    posted: reportPosted,
                    date_posted: this.formatDateTime(term.date_posted),
                    date_scheduled: this.formatDateTime(term.date_scheduled),
                } 
            })
        },

        formatDateTime(dateTime) {
            if (!dateTime) return '';
            const [date, time] = dateTime.split(' ');
            let [hours, minutes, seconds] = time.split(':');
            hours = parseInt(hours);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;
            return `${date} ${formattedTime}`;
        },
        editTerm(item){
            const [dateScheduled, timeScheduled] = item.date_scheduled ? item.date_scheduled.split(' ') : ['', ''];
            this.dateScheduled = dateScheduled;
            this.timeScheduled = timeScheduled;
            this.editedItem = item;
            this.cardPostReport = true;
            this.dialog = true;
        },
        cancel(){
            this.dialog = false;
        },
        async postReports(){
            this.cardPostReport = false;
            this.postingText = 'Posting reports please stand by'
            this.$nextTick(()=>{
                this.expand = true;
            })
            let termRecord = Object.assign({}, this.editedItem);
            termRecord['posted'] = 1;
            let date = new Date();
            termRecord['date_posted'] = date.toLocaleString("sv-SE");
            this.setEditedTerm(termRecord);            
            try {
                await this.postTermReports();
                this.editedItem['posted'] = 'posted';
                this.editedItem['date_posted'] = date.toLocaleString("sv-SE");
                this.expand = false;
                this.$nextTick(()=>{
                    this.dialog = false;
                })
                
                setTimeout(() => {
                    this.snackText = this.editedItem.year + ' Term ' + this.editedItem.term + ' reports posted'                    
                    this.snackbar = true;
                })
                //console.log(response)
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        },
        async removeReports(){
            this.cardPostReport = false;
            this.postingText = 'Removing reports please stand by'
            this.$nextTick(()=>{
                this.expand = true;
            })
            let termRecord = Object.assign({}, this.editedItem);
            termRecord['posted'] = 0;            
            termRecord['date_posted'] = null;
            //console.log(termRecord);
            this.setEditedTerm(termRecord);            
            try {
                await this.postTermReports();
                this.editedItem['posted'] = 'not posted';
                this.editedItem['date_posted'] = null;
                this.expand = false;
                this.$nextTick(()=>{
                    this.dialog = false;
                })
                
                setTimeout(() => {
                    this.snackText = this.editedItem.year + ' Term ' + this.editedItem.term + ' reports removed'
                    this.snackbar = true;
                })
                //console.log(response)
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
        },

        async scheduleNow () {
            let termRecord = Object.assign({}, this.editedItem);
            const postTime = this.timeScheduled ? this.timeScheduled : '00:00';
            const timestamp = `${this.dateScheduled} ${postTime}:00`;
            termRecord['run_at'] = timestamp;
            this.setEditedTerm(termRecord);  
            try {
                await this.scheduleTermReports(termRecord);
                await this.initialize();
                this.expand = false;
                this.$nextTick(()=>{
                    this.dialog = false;
                })
                
                setTimeout(() => {
                    this.snackText = `${ this.editedItem.year } Term ${ this.editedItem.term } reports scheduled to run at ${timestamp}`
                    this.snackbar = true;
                })
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
        }
    }
}
</script>